export const ADDBOOK = "books/AddNewBook";
export const EDITBOOK = "books/EditBook";
export const DELETEBOOK = "books/DeleteBook";
export const SET_UPDATE_BOOK_ID = "books/SetUpdateBookId";
export const LOADED = "books/Loaded";

